import React, { memo } from 'react'
import { string } from 'prop-types'
import { useTheme } from 'emotion-theming'

export const ExpertAccountType = memo(({ width = '61px', height = '73px' }) => {
	const {
		colors: { primary, secondary },
	} = useTheme()

	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 61 73">
			<g fill="none" fillRule="evenodd">
				<path
					fill={secondary}
					fillRule="nonzero"
					d="M52.39 41.77l-6.66-1.89-.09 1.44c3.24.99 6.12 2.88 6.12 6.21v6.93c0 2.61-1.53 4.68-3.6 5.67h4.23c3.24 0 5.85-2.61 5.85-5.85V47.8c.09-3.33-2.7-5.13-5.85-6.03zM30.61 1.45c-1.35 0-2.7.18-3.96.54 6.84 1.8 11.88 7.92 11.88 15.3v8.37c0 7.38-5.04 13.59-11.88 15.3 1.26.27 2.61.54 3.96.54 8.82 0 15.84-7.11 15.84-15.84v-8.37c0-8.73-7.02-15.84-15.84-15.84z"
				/>
				<path
					stroke={secondary}
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth="2.7"
					d="M30.61 1.45c-8.82 0-15.84 7.11-15.84 15.84v8.37c0 8.82 7.11 15.84 15.84 15.84 8.82 0 15.84-7.11 15.84-15.84v-8.37c0-8.73-7.02-15.84-15.84-15.84z"
				/>
				<path
					stroke={primary}
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth="2.7"
					d="M47.08 40.42l6.66 1.89c3.06.9 5.85 2.7 5.85 5.85v6.48c0 3.33-2.7 5.85-5.85 5.85H7.3c-3.33 0-5.85-2.7-5.85-5.85v-6.39c0-3.24 2.79-4.95 5.85-5.85l6.93-1.89"
				/>
				<path
					stroke={primary}
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth="2.7"
					d="M30.61 1.45c-8.82 0-15.84 7.11-15.84 15.84v8.37c0 8.82 7.11 15.84 15.84 15.84 8.82 0 15.84-7.11 15.84-15.84v-8.37c0-8.73-7.02-15.84-15.84-15.84z"
				/>
				<path
					fill={secondary}
					fillRule="nonzero"
					stroke={primary}
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth="2.7"
					d="M30.52 47.26l3.87 7.92 8.64 1.26-6.21 6.03 1.44 8.64-7.74-4.05-7.74 4.05 1.44-8.64-6.3-6.03 8.73-1.26z"
				/>
			</g>
		</svg>
	)
})
ExpertAccountType.propTypes = {
	width: string,
	height: string,
}
